import { render, staticRenderFns } from "./IconBlank02.vue?vue&type=template&id=65f60476"
import script from "./IconBlank02.vue?vue&type=script&lang=ts"
export * from "./IconBlank02.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports